import React, { Component } from 'react';
import {
    ProfileMenuVerificationIDWrapper,
    ProfileVerificationHeaderWrapper,
    BackButton,
    ProfileMenuVerificationHeader,
    ContentWrapper,
    TopCard,
    LowerButtonsWrapper,
    SaveButton,
    CancelButton,
    FooterWrapper,
    FooterItemTextStyle,
    FooterItemCompanyTextStyle,
} from './Styled';
import { ArrowBack } from '../../../styles/Styled';
import FormUploadFileCrop from '../FormUploadFileCrop';

export class ProfileMenuVerificationID extends Component {
    constructor(props) {
        super(props);
        this.footerItems = [
            { item: 'About us', link: '' },
            { item: 'Help', link: '' },
            { item: 'Jobs', link: '' },
            { item: 'Privacy Policy', link: '' },
            { item: 'Terms', link: '' },
        ];
        
    }
    render() {
        return (
            <ProfileMenuVerificationIDWrapper>
                <ProfileVerificationHeaderWrapper
                    onClick={this.props.BackCurrentPage}
                >
                    <BackButton>
                        <ArrowBack />
                        <ProfileMenuVerificationHeader>
                            Back
                        </ProfileMenuVerificationHeader>
                    </BackButton>
                </ProfileVerificationHeaderWrapper>
                <ContentWrapper>
                    <TopCard>
                        <FormUploadFileCrop
                            align={'center'}
                        />
                    </TopCard>
                    <TopCard >
                        <FormUploadFileCrop
                                align={'center'}
                            />
                    </TopCard>
                    <LowerButtonsWrapper>
                        <SaveButton>Save</SaveButton>
                        <CancelButton>Cancel</CancelButton>
                    </LowerButtonsWrapper>
                    <FooterWrapper>
                        <div>
                            {this.footerItems.map((item, index) => (
                                <FooterItemTextStyle
                                    key={index}
                                    last={index}
                                    first={index === 0}
                                >
                                    {item.item} {index !== 4 && '|'}
                                </FooterItemTextStyle>
                            ))}
                        </div>
                        <FooterItemCompanyTextStyle>
                            © 2020 RealtyFeed
                        </FooterItemCompanyTextStyle>
                    </FooterWrapper>
                </ContentWrapper>
            </ProfileMenuVerificationIDWrapper>
        );
    }
}

export default ProfileMenuVerificationID;
